import ButtonInputModal from './toolbar/buttonInputModal';

const Modals = {
  BUTTON_INPUT: 'button-input',
};

const ModalsMap = {
  [Modals.BUTTON_INPUT]: ButtonInputModal,
};

export { Modals, ModalsMap };
